import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Popover, Box, Alert, LinearProgress, Divider, Typography } from '@mui/material'

import { formatDateToBEFormatDateFns } from 'utils/date'
import { useLazyGetAllConfiguredServicesQuery } from 'api/configured-service/searchConfiguredServices'
import T from 'T'
import ServicesList from './ServicesList'

const MAX_ROWS = 5

const LocationServicesPopover = ({ anchorEl, onClose, accountId, locationId }) => {
  const isOpen = Boolean(anchorEl)
  const [getAllConfiguredServices, { data: servicesData = [], isLoading, error }] = useLazyGetAllConfiguredServicesQuery()

  useEffect(() => {
    if (isOpen && (accountId || locationId)) {
      const today = new Date()
      getAllConfiguredServices({
        accountId: accountId || '',
        locationId: locationId || '',
        startDate: formatDateToBEFormatDateFns(today),
        endDate: formatDateToBEFormatDateFns(today),
        statuses: ['Active'],
      })
    }
  }, [isOpen, accountId, locationId, getAllConfiguredServices])

  const services = servicesData || []
  const rows = services.slice(0, MAX_ROWS)
  const extraRows = services.length - MAX_ROWS

  const handleClose = () => {
    onClose()
  }

  return (
    <Popover
      sx={{ pointerEvents: 'none' }}
      open={isOpen}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
            minWidth: 280,
            maxWidth: 320,
          },
        },
      }}
    >
      <Box sx={{ p: 0 }}>
        {isLoading && <LinearProgress />}

        {error && <Alert severity="error">{T.FAILED_TO_LOAD_SERVICES}</Alert>}

        <ServicesList services={rows} />

        {extraRows > 0 && (
          <>
            <Divider />
            <Typography m={2} variant="caption" display="flex" justifyContent="end">
              {`+${extraRows} more`}
            </Typography>
          </>
        )}
      </Box>
    </Popover>
  )
}

LocationServicesPopover.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.string,
  locationId: PropTypes.string,
}

export default LocationServicesPopover
